import * as React from "react";
import Slider from "react-slick";
import { graphql, StaticQuery } from "gatsby";
import { Location } from '@reach/router';

import Link from "components/Link";
import zparse from "helpers/zparse";
import DataProvider from 'providers/data';

const SmartQuickLinksHandler = props => {

	return (
		<StaticQuery
			query={graphql`
				query AllSmartQuicklinks {
					allComponentsQuicklink {
						edges {
							node {
								id
								
								title
								links

								featured1Icon
								featured1Body
								featured1Link
								
								featured2Icon
								featured2Body
								featured2Link
							}
						}
					}
				}
			`}
			render={(data) => {
				if (!props.id) return null;

				const { edges } = data.allComponentsQuicklink;
				let quicklinks = edges.map(({ node }) => node);
				if ((props.providerResponse.data.length > 0 || !!quicklinks !== false) && props.providerStatusText === "LOADED") {
					quicklinks = props.providerResponse.data;
				}

				quicklinks = quicklinks.filter((quicklink) => {
					return quicklink.id === props.id
				})

				if (quicklinks.length === 0) return null;

				const quicklinksMenu = quicklinks[0];

				let featuredLinks = [{
					icon: quicklinksMenu.featured1Icon,
					body: quicklinksMenu.featured1Body,
					link: quicklinksMenu.featured1Link
				}];

				if (quicklinksMenu.featured2Icon !== null || quicklinksMenu.featured2Body !== null) {
					featuredLinks.push({
						icon: quicklinksMenu.featured2Icon,
						body: quicklinksMenu.featured2Body,
						link: quicklinksMenu.featured2Link
					})
				}

				const settings = {
					arrows: false,
					dots: true,
					infinite: false,
					speed: 500,
					autoplay: false,
					autoplaySpeed: 10000,
					slidesToShow: 1,
					slidesToScroll: 1,
					// adaptiveHeight: true,
				};

				return (
					<section id="quicklinks-menu">
						<div className="grid-container">
							<div className="grid-x grid-padding-x align-middle">
								<div className="cell small-12 medium-5">
									<div className="links">
										<h2>{quicklinksMenu.title}</h2>
										{quicklinksMenu.links.length > 0 && (
											<ul>
												{quicklinksMenu.links.map((link, index) => {
													return (
														<li key={`quicklink-${index}-${link.linkText}`}><Link to={link.link}>{link.linkText}</Link></li>
													)
												})}
											</ul>
										)}
									</div>
								</div>
								<div className="cell small-12 medium-7">
									{featuredLinks.length > 0 && (
										<>
											<div className="featured-links mobile show-for-small-only">
												<Slider {...settings}>
													{featuredLinks.map((link, index) => {
														return (
															<div key={`featuredlink-mobile-${index}-${link}`}>
																<div className={`featured-link ${index === 0 ? "first" : ""}`}>
																	<img src={link.icon} alt="" />
																	{
																		link.link ?
																			<Link to={link.link ? link.link : "#"} className={`${link.link ? "" : "no-link"}`}>
																				{zparse(link.body)}
																			</Link>
																			:
																			<>
																				{zparse(link.body)}
																			</>
																	}
																</div>
															</div>
														)
													})}
												</Slider>
											</div>
											<div className="featured-links hide-for-small-only">
												{featuredLinks.map((link, index) => {
													return (
														<div className={`featured-link ${index === 0 ? "first" : ""}`} key={`featuredlink-${index}-${link}`}>
															<img src={link.icon} alt="" />
															{
																link.link ?
																	<Link to={link.link ? link.link : "#"} className={`${link.link ? "" : "no-link"}`}>
																		{zparse(link.body)}
																	</Link>
																	:
																	<>
																		{zparse(link.body)}

																	</>
															}
														</div>
													)
												})}
											</div>
										</>
									)}
								</div>
							</div>
						</div>
					</section>
				)

			}} />

	);

}

const SmartQuickLinks = props => {
	return (
		<Location>
			{locationProps => <DataProvider liveRefresh={true} type="ComponentsQuicklink"><SmartQuickLinksHandler {...props} location={locationProps.location} /></DataProvider>}
		</Location>
	)
}

export default SmartQuickLinks;